import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { VehicleExempt } from '@EcamModel/model/VehicleExempt';
import { AxiosInstance } from 'axios';
import { IGetListVehicleExemptProps } from '../IVehicleExemptHttpController';
import { Paging } from '@Core';

export class VehicleExemptHttpController extends BaseHttpController<VehicleExempt> {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'vehicle-exempt', client);
    }

    async list(props: IGetListVehicleExemptProps): Promise<Paging<VehicleExempt>> {
        return await this.doPost({ path: 'filter', body: props }).then((res) => res.data);
    }

    async deleteMultipleVehicleExempt(ids: number[]): Promise<boolean> {
        return await this.doPost({ path: 'delete-multiple-vehicle-exempt', body: { ids } }).then((res) => res.data);
    }
}
